import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  badgeSection: {
    display: "flex",
    gap: "6px",
  },
  assignedAgentCard: {
    padding: "20px 16px",
    width: "314px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  upperSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  lowerSection: {
    display: "flex",
    alignItems: "flex-start",
    gap: "16px",
    marginTop: "12px",
  },
  avatarWrapper: {
    position: "relative",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFF",
    boxShadow:
      "0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
  },
}));
